// Filtre une liste d'items de menu [{label, path, ...}] selon les permissions du
// compte staff LIMITE (cree par le superadmin pour une tache precise, cf.
// companies.models.AdminMenuPermission) actuellement "entre" dans cette company.
// `menuKeys` = company.menu_keys (CompanyMeView) : null = pas de restriction
// (connexion normale de la company, ou superadmin non limite) -> renvoie la liste
// telle quelle ; tableau = seuls les items dont le path est dedans sont gardes
// (un item sans path, càd un stub desactive, est toujours exclu).
export const filterMenuItems = (items, menuKeys) => {
  if (!Array.isArray(menuKeys)) return items;
  const allowed = new Set(menuKeys);
  return items.filter((item) => item.path && allowed.has(item.path));
};
